import type { AsyncReturnType } from "type-fest";
import type {
  TimingEvent,
  TimingSpan,
  TimingSpanWithEndTime,
  TimingSpanWithoutEndTime,
  TimingStrategy,
} from "../types";

/**
 * Strategy implementation for noop timing.
 */
export class NoopTimingStrategy implements TimingStrategy {
  public startSpan(_span: TimingSpanWithoutEndTime): void {
    // This space intentionally left blank
  }

  public endSpan(_span: TimingSpanWithEndTime): void {
    // This space intentionally left blank
  }

  public createSpan(_span: TimingSpan): void {
    // This space intentionally left blank
  }

  // biome-ignore lint/suspicious/noExplicitAny: Need to match ReturnType<F>, which uses any
  public async withSpan<F extends () => Promise<any>>(
    _span: TimingSpanWithoutEndTime,
    callback: F,
  ): Promise<AsyncReturnType<F>> {
    return await callback();
  }

  public createEvent(_event: TimingEvent): void {
    // This space intentionally left blank
  }

  public reset(): void {
    // This space intentionally left blank
  }
}
